import { SITE } from './site.data';

export function canonicalUrl(path: string): string {
  const baseUrl = SITE.baseUrl.replace(/\/$/, '');

  if (!path || path === '/') {
    return `${baseUrl}/`;
  }

  const normalizedPath = path.replace(/^\/+/, '').replace(/\/+$/, '');

  return `${baseUrl}/${normalizedPath}/`;
}
